export default __webpack_public_path__ + "static/media/cheatday_frenchfries@2x.af41c6c3.jpg";